import { render, staticRenderFns } from "./SearchHistoryTable.vue?vue&type=template&id=d8fe512a&"
import script from "./SearchHistoryTable.vue?vue&type=script&lang=ts&"
export * from "./SearchHistoryTable.vue?vue&type=script&lang=ts&"
import style0 from "./SearchHistoryTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports